import { PLAN_VIVIR_SEGURO } from "../../../utils/constanst";

const InitPage =0;
const env = process.env.NODE_ENV;
const setData = false;
const isDevelopment = env === "development";
const setObj = obj => setData ? ({ ...obj }) : ({});



export const catalogosDefault = {
    actividadEconomica: [],
    coberturas: [],
    rates: [],
    sumaAsegurada:[],
    fees:[]
}

export const Beneficiarios = {
    nombresApellidos1: '',
    parentezco1: '',
    edad1: '',
    porcentajeBeneficio1: '',
    tipoIdentificacionRepresentante1: '',
    numeroIdentificacionRepresentante1: '',
    nombreRepresentante1: '',
    apellidoRepresentante1: ''
};

export const tarificacionDefault = {
    itipopol: 'I',
    VigenciaPol: 'A',
    ncuotas: 1,
    marca: 0,
    modelo: -1,
    anio: 0,
    tipo: 0,
    cate: 0,
    usoo: 1,
    nasiento: 0,
    valn: 0,
    suma: 0,
    valnreal: 0,
    GPS: 0,
    dedu: 0,
    rsat: 1,
    auNuevo: 0,
    showDialogFail: false
};


const VivirSeguroMochaded = isDevelopment ? {
    tipoIdentidad: '1',
    numeroIdentificacion: '570-050591-0000M',
    nombres: 'EDDY ANTONIO',
    apellidos: 'ORTIZ AMADOR',
    fechaNacimiento:'',
    edad:31,
    estadoCivil: '1',
    telefonoCasa: '2222-2222',
    telefonoPersonal: '8888-8888',
    correoElectronico: 'eortiza@lafise.com',
    autorizaASL: true,
    aceptaPocesoArbitraje: true,
    actividadEconomica: '4',
    empresaTrabaja: 'Seguros LAFISE',
    telefonoEmpresa: '22534397',
    ocupacionActual: 'Analista Programador BI',
    monedaIngreso: '1',
    montoIngreso: '10000',
    origenFondo: '2',
    planSeguro: '',
    cuotas: '',
    esTelepago: undefined,
    nombresApellidos1: 'Eddy Ortiz Jr',
    parentesco1: 'H',
    edad1: 11,
    porcentajeBeneficio1: 100,
    tipoIdentificacionRepresentante1: '1',
    numeroIdentificacionRepresentante1: '570-050591-0000M',
    nombreRepresentante1: 'Eddy Antonio',
    apellidoRepresentante1: 'Ortiz Amador',
    nombresApellidos2: 'Gabriel Ortiz',
    parentesco2: '10',
    edad2: 7,
    porcentajeBeneficio2: 50,
    tipoIdentificacionRepresentante2: '1',
    numeroIdentificacionRepresentante2: '568-000001-0015A',
    nombreRepresentante2: 'Eddy Antonio 2',
    apellidoRepresentante2: 'Ortiz Amador 2',
    init: false,
    mensaje: '',
} : {};

export const VivirSeguroDefault = {
    idPlan: PLAN_VIVIR_SEGURO,
    tipoIdentidad: '1',
    numeroIdentificacion: '',
    nombres: '',
    apellidos: '',
    fechaNacimiento:'',
    edad:0,
    estadoCivil: '',
    telefonoCasa: '',
    telefonoPersonal: '',
    correoElectronico: '',
    autorizaASL: undefined,
    aceptaPocesoArbitraje: undefined,
    actividadEconomica: '',
    empresaTrabaja: '',
    telefonoEmpresa: '',
    ocupacionActual: '',
    monedaIngreso: '',
    montoIngreso: '',
    origenFondo: '',
    planSeguro: '',
    suma: 0,
    esTelepago: undefined,
    nombresApellidos1: '',
    parentesco1: '',
    edad1: 0,
    porcentajeBeneficio1: 0,
    tipoIdentificacionRepresentante1: '',
    numeroIdentificacionRepresentante1: '',
    nombreRepresentante1: '',
    apellidoRepresentante1: '',
    esBeneficiario2: false,
    nombresApellidos2: '',
    parentesco2: '',
    edad2: 0,
    porcentajeBeneficio2: 0,
    tipoIdentificacionRepresentante2: '',
    numeroIdentificacionRepresentante2: '',
    nombreRepresentante2: '',
    apellidoRepresentante2: '',
    tablecober:[],
    cuota: 0,
    montoCuota: 0,
    descCuota: '',
    montoPagar:0,
    montoPagarVisualizar:0,
    init: false,
    src:'',
    mensaje: '',
    numeroSolicitud: '00000',
    guardado: false,
    catalogos: { ...catalogosDefault },
    tarificacion: { ...tarificacionDefault },
    setTarificacion: (obj) => { },
    setCatalogos: (obj) => { },
    ...setObj(VivirSeguroMochaded)
};


export { InitPage };
